import { TestAIAgentFile } from 'api/ai-agents/requests';
import { VariableValue } from 'api/types';

export const FILE_PREFIX = 'file_field-';

type BuildTestPayloadArgs = {
  actionId: string;
  websocketId: string;
  formValues: Record<string, unknown>;
  additionalFiles: Array<VariableValue>;
};

export const buildTestPayload = ({
  actionId,
  websocketId,
  formValues,
  additionalFiles,
}: BuildTestPayloadArgs) => {
  const testValues = Object.fromEntries(
    Object.entries(formValues).filter(([key]) => !key.startsWith(FILE_PREFIX)),
  );
  const files: Array<TestAIAgentFile> = additionalFiles.map((file) =>
    file.variables
      ? (formValues[
          `${FILE_PREFIX}${file.value.replace('{{ ', '').replace(' }}', '')}`
        ] as TestAIAgentFile)
      : file.value,
  );
  return { actionId, websocketId, additionalFiles: files, testValues };
};
